import React from 'react';
import { useTheme, ThemePreference } from '../hooks/useTheme';
import './ThemeToggle.css';

const LABELS: Record<ThemePreference, string> = {
  auto: 'Motyw: automatyczny',
  light: 'Motyw: jasny',
  dark: 'Motyw: ciemny',
};

const NEXT: Record<ThemePreference, string> = {
  auto: 'jasny',
  light: 'ciemny',
  dark: 'automatyczny',
};

/** Sun, moon, or half-filled circle for "follow the system". */
function ThemeIcon({ preference }: { preference: ThemePreference }) {
  if (preference === 'light') {
    return (
      <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true">
        <circle cx="8" cy="8" r="3.2" fill="currentColor" />
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => (
          <line
            key={angle}
            x1="8"
            y1="1.4"
            x2="8"
            y2="3"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            transform={`rotate(${angle} 8 8)`}
          />
        ))}
      </svg>
    );
  }

  if (preference === 'dark') {
    return (
      <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true">
        <path
          d="M13.2 9.8A5.6 5.6 0 0 1 6.2 2.8a5.8 5.8 0 1 0 7 7Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true">
      <circle cx="8" cy="8" r="5.4" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <path d="M8 2.6a5.4 5.4 0 0 1 0 10.8Z" fill="currentColor" />
    </svg>
  );
}

const ThemeToggle: React.FC = () => {
  const { preference, resolved, cycle } = useTheme();

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={cycle}
      // The visible control is an icon, so the state has to be said out loud.
      aria-label={`${LABELS[preference]}${
        preference === 'auto' ? ` (teraz ${resolved === 'dark' ? 'ciemny' : 'jasny'})` : ''
      }. Kliknij, aby przełączyć na ${NEXT[preference]}.`}
      title={LABELS[preference]}
    >
      <ThemeIcon preference={preference} />
    </button>
  );
};

export default ThemeToggle;
